import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit {

  gridCols = 1;

  ngOnInit(): void {
    //this.gridCols = window.innerWidth / 400;
    this.gridCols = (window.innerWidth <= 900 ) ? 1 : 4;
    
  }

  onResize(event: any) {
    this.gridCols = (window.innerWidth <= 900 ) ? 1 : 4;
    //this.gridCols = window.innerWidth / 400;
  }

}
